import { useState } from "react";
import { Formik, Form as FormikForm } from "formik";
import Form from "react-bootstrap/Form";
import * as yup from "yup";
import axios from "axios";
import InputGroup from "react-bootstrap/InputGroup";
import { useApiContext } from "../../context/ApiContext";
import DeleteBtnModal from "../../components/DeleteBtnModal";
import DeliveryTypeTable from "./DeliveryTypeTable";

const initialValues = {
  name: "",
  price: "",
  time: "",
  d_status: "",
};

const schema = yup.object().shape({
  name: yup.string().required("Type is a required field!"),
  price: yup.string().required("Type Price is a required field!"),
  time: yup.string(),
  d_status: yup.string(),
});

const validate = (values) => {
  let errors = {};

  if (values.price) {
    if (/^[0-9.\b]+$/.test(values.price) === false) {
      errors.price = "Only number!";
    } else if (/^\d{0,8}(\.\d{0,2})?$/.test(values.price) === false) {
      errors.price =
        "Maximum 8 digits before the decimal point & Maximum 2 digits after the decimal point!";
    }
  }

  return errors;
};

const DeliveryType = () => {
  const { unpaginate_delivery_type } = useApiContext();

  const [message, setMessage] = useState();
  const [item, setItem] = useState({});

  const AddDeliveryTypeFunc = async (values) => {
    let formfield = new FormData();

    formfield.append("name", values.name);
    formfield.append("price", values.price);
    formfield.append("time", values.time);
    formfield.append("d_status", values.d_status);

    await axios({
      method: "POST",
      url: `${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_UNP_DELIVERY_TYPE_URL}`,
      data: formfield,
    })
      .then((response) => {
        setMessage(response.success, "Delivery Type is successfuly created...");
        window.location.reload(false);
      })
      .catch((error) => {
        setMessage(error.message, "Error");
      });
  };

  const submitAddDeliveryTypeForm = async (
    values,
    { setErrors, setSubmitting, resetForm }
  ) => {
    try {
      AddDeliveryTypeFunc(values);
      setSubmitting(false);
      // resetForm();
    } catch (error) {
      setErrors({ error: error.message });
    }
  };

  const updatedValues = {
    name: item.name ? item.name : "",
    price: item.price ? item.price : "",
    time: item.time ? item.time : "",
    d_status: item.d_status ? item.d_status : "",
  };

  const UpdateDeliveryTypeFunc = async (values) => {
    let formfield = new FormData();

    formfield.append("name", values.name);
    formfield.append("price", values.price);
    formfield.append("time", values.time);
    formfield.append("d_status", values.d_status);

    await axios({
      method: "PUT",
      url: `${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_UNP_DELIVERY_TYPE_URL}${item.id}/`,
      data: formfield,
    })
      .then((response) => {
        setMessage(
          response.success,
          "Delivery Type is successfully updated..."
        );
        window.location.reload(false);
      })
      .catch((error) => {
        setMessage(error.message, "Error");
      });
  };

  const submitUpdateDeliveryTypeForm = async (
    values,
    { setErrors, setSubmitting }
  ) => {
    try {
      UpdateDeliveryTypeFunc(values);
      setSubmitting(false);
    } catch (error) {
      setErrors({ err: error.message });
    }
  };

  const updateDeliveryType = async (id) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_UNP_DELIVERY_TYPE_URL}${id}/`
    );
    setItem(data);
  };

  return (
    <>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-6">
                <div className="mx-3 my-2 page-title-box d-sm-flex align-items-center justify-content-start">
                  <h4 className="mb-sm-0">Delivery Type</h4>
                </div>
              </div>

              <div className="col-6">
                <div className="d-flex mx-3 my-2  align-items-center justify-content-end">
                  <button
                    className="btn btn-secondary mb-4"
                    data-bs-toggle="modal"
                    data-bs-target="#DeliveryTypeAddModal"
                  >
                    <i className="bi bi-plus-circle align-baseline me-1"></i>{" "}
                    Add Delivery Type
                  </button>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-body">
                    <div className="table-responsive">
                      <DeliveryTypeTable
                        unpaginate_delivery_type={unpaginate_delivery_type}
                        updateDeliveryType={updateDeliveryType}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <!--Add Modal --> */}
      <div
        className="modal fade"
        id="DeliveryTypeAddModal"
        tabIndex="-1"
        aria-labelledby="DeliveryTypeAddModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <Formik
              initialValues={initialValues}
              validationSchema={schema}
              onSubmit={submitAddDeliveryTypeForm}
              validate={validate}
            >
              {({
                handleSubmit,
                handleChange,
                values,
                touched,
                errors,
                isSubmitting,
              }) => (
                <FormikForm noValidate onSubmit={(e) => handleSubmit(e)}>
                  <div className="modal-header">
                    <h5 className="modal-title" id="DeliveryTypeAddModalLabel">
                      Add Delivery Type
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      id="close-addAgentModal"
                    ></button>
                  </div>

                  <div className="modal-body">
                    <Form.Group className="form-outline mb-4">
                      <Form.Label>
                        Type Name<span>*</span>
                      </Form.Label>
                      <InputGroup hasValidation>
                        {/* <InputGroup.Text>@</InputGroup.Text> */}
                        <Form.Control
                          type="text"
                          name="name"
                          id="name"
                          value={values.name}
                          onChange={handleChange}
                          isInvalid={!!touched.name && !!errors.name}
                          isValid={touched.name && !errors.name}
                          className="form-control"
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.name}
                        </Form.Control.Feedback>
                      </InputGroup>
                    </Form.Group>

                    <Form.Group className="form-outline mb-4">
                      <Form.Label>
                        Type Price<span>*</span>
                      </Form.Label>
                      <InputGroup hasValidation>
                        {/* <InputGroup.Text>@</InputGroup.Text> */}
                        <Form.Control
                          type="text"
                          name="price"
                          id="price"
                          value={values.price}
                          onChange={handleChange}
                          isInvalid={!!touched.price && !!errors.price}
                          isValid={touched.price && !errors.price}
                          className="form-control"
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.price}
                        </Form.Control.Feedback>
                      </InputGroup>
                    </Form.Group>

                    <Form.Group className="form-outline mb-4">
                      <Form.Label>
                        Type Time<span>*</span>
                      </Form.Label>
                      <InputGroup hasValidation>
                        {/* <InputGroup.Text>@</InputGroup.Text> */}
                        <Form.Control
                          type="text"
                          name="time"
                          id="time"
                          value={values.time}
                          onChange={handleChange}
                          isInvalid={!!touched.time && !!errors.time}
                          isValid={touched.time && !errors.time}
                          className="form-control"
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.time}
                        </Form.Control.Feedback>
                      </InputGroup>
                    </Form.Group>

                    <Form.Group className="form-outline mb-4">
                      <Form.Label>
                        Status<span></span>
                      </Form.Label>
                      <InputGroup hasValidation>
                        {/* <InputGroup.Text>@</InputGroup.Text> */}
                        <Form.Select
                          name="d_status"
                          id="d_status"
                          value={values.d_status}
                          onChange={handleChange}
                          isInvalid={!!touched.d_status && !!errors.d_status}
                          isValid={touched.d_status && !errors.d_status}
                          className="form-control"
                        >
                          <option value="">Select</option>
                          <option value={`${true}`}>Active</option>
                          <option value={`${false}`}>Inactive</option>
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.d_status}
                        </Form.Control.Feedback>
                      </InputGroup>
                    </Form.Group>
                  </div>

                  <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <button type="reset" className="btn btn-danger">
                        Cancel
                      </button>

                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={isSubmitting}
                      >
                        Add
                      </button>
                    </div>
                  </div>

                  {/* message  */}
                  {message && <h2 className="text-center m-5">{message}</h2>}
                </FormikForm>
              )}
            </Formik>
          </div>
        </div>
      </div>

      {/* update Modal */}
      <div
        className="modal fade"
        id="DeliveryTypeUpdateModal"
        tabIndex="-1"
        aria-labelledby="DeliveryTypeUpdateModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <Formik
              enableReinitialize={true}
              initialValues={updatedValues}
              validationSchema={schema}
              onSubmit={submitUpdateDeliveryTypeForm}
              validate={validate}
            >
              {({
                handleSubmit,
                handleChange,
                values,
                touched,
                errors,
                isSubmitting,
              }) => (
                <FormikForm noValidate onSubmit={(e) => handleSubmit(e)}>
                  <div className="modal-header">
                    <h5
                      className="modal-title"
                      id="DeliveryTypeUpdateModalLabel"
                    >
                      Update Delivery Type
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      id="close-addAgentModal"
                    ></button>
                  </div>

                  <div className="modal-body">
                    <Form.Group className="form-outline mb-4">
                      <Form.Label>
                        Type Name<span>*</span>
                      </Form.Label>
                      <InputGroup hasValidation>
                        {/* <InputGroup.Text>@</InputGroup.Text> */}
                        <Form.Control
                          type="text"
                          name="name"
                          id="name"
                          value={values.name}
                          onChange={handleChange}
                          isInvalid={!!touched.name && !!errors.name}
                          isValid={touched.name && !errors.name}
                          className="form-control"
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.name}
                        </Form.Control.Feedback>
                      </InputGroup>
                    </Form.Group>

                    <Form.Group className="form-outline mb-4">
                      <Form.Label>
                        Type Price<span>*</span>
                      </Form.Label>
                      <InputGroup hasValidation>
                        {/* <InputGroup.Text>@</InputGroup.Text> */}
                        <Form.Control
                          type="text"
                          name="price"
                          id="price"
                          value={values.price}
                          onChange={handleChange}
                          isInvalid={!!touched.price && !!errors.price}
                          isValid={touched.price && !errors.price}
                          className="form-control"
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.price}
                        </Form.Control.Feedback>
                      </InputGroup>
                    </Form.Group>

                    <Form.Group className="form-outline mb-4">
                      <Form.Label>
                        Type Time<span>*</span>
                      </Form.Label>
                      <InputGroup hasValidation>
                        {/* <InputGroup.Text>@</InputGroup.Text> */}
                        <Form.Control
                          type="text"
                          name="time"
                          id="time"
                          value={values.time}
                          onChange={handleChange}
                          isInvalid={!!touched.time && !!errors.time}
                          isValid={touched.time && !errors.time}
                          className="form-control"
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.time}
                        </Form.Control.Feedback>
                      </InputGroup>
                    </Form.Group>

                    <Form.Group className="form-outline mb-4">
                      <Form.Label>
                        Status<span></span>
                      </Form.Label>
                      <InputGroup hasValidation>
                        {/* <InputGroup.Text>@</InputGroup.Text> */}
                        <Form.Select
                          name="d_status"
                          id="d_status"
                          value={values.d_status}
                          onChange={handleChange}
                          isInvalid={!!touched.d_status && !!errors.d_status}
                          isValid={touched.d_status && !errors.d_status}
                          className="form-control"
                        >
                          <option value="">Select</option>
                          <option value={`${true}`}>Active</option>
                          <option value={`${false}`}>Inactive</option>
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.d_status}
                        </Form.Control.Feedback>
                      </InputGroup>
                    </Form.Group>
                  </div>

                  <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <button type="reset" className="btn btn-danger">
                        Cancel
                      </button>

                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={isSubmitting}
                      >
                        Update
                      </button>
                    </div>
                  </div>

                  {/* message  */}
                  {message && <h2 className="text-center m-5">{message}</h2>}
                </FormikForm>
              )}
            </Formik>
          </div>
        </div>
      </div>

      <DeleteBtnModal id={`DeliveryTypeDeleteModal`} />
    </>
  );
};

export default DeliveryType;
